import React, { useEffect, useState } from "react";

import { cn } from "../../../../lib/utils";
import FrameExtenderRadioGroup from "./FrameExtenderRadioGroup";

const FrameExtender = ({ methods, isOpen: { FrameExtender } }) => {
    const extenders_side = ["none", "side 35"];
    const extenders_top = ["none", "top 35"];

    const [selectedExtender, setSelectedExtender] = useState("side");
    const [selectedExtenderArray, setselectedExtenderArray] =
        useState(extenders_side);

    useEffect(() => {
        if (selectedExtender === "top") {
            setselectedExtenderArray(extenders_top);
        } else {
            setselectedExtenderArray(extenders_side);
        }
    }, [selectedExtender]);

    return (
        <div
            className={cn(
                "section flex flex-col gap-6 transition-all h-0 opacity-0",
                {
                    ["h-full opacity-100"]: FrameExtender.isOpen,
                }
            )}
        >
            <div className="flex w-full gap-4 py-2">
                <button
                    type="button"
                    className={cn("uppercase text-gray-700 text-xs", {
                        ["text-primary border-b border-b-primary"]:
                            selectedExtender === "side",
                    })}
                    onClick={() => setSelectedExtender("side")}
                >
                    Side
                </button>
                <button
                    type="button"
                    className={cn("uppercase text-gray-700 text-xs", {
                        ["text-primary border-b border-b-primary"]:
                            selectedExtender === "top",
                    })}
                    onClick={() => setSelectedExtender("top")}
                >
                    Top
                </button>
            </div>

            <div className="flex flex-wrap [&>div]:max-w-1/4 gap-4 ">
                <FrameExtenderRadioGroup
                    {...methods}
                    extenders={selectedExtenderArray}
                    side={selectedExtender}
                />
            </div>
        </div>
    );
};

export default FrameExtender;
